// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Select } from '../../../ui/forms';
import { loadCities } from '../../../../libs/pagewidget';

class CitySelect extends PureComponent {
  state = {
    isLoading: true,
    cities: {},
    error: false,
  }

  componentDidMount() {
    if (this.props.clientInf) {
      this.loadOptions(this.props.clientInf.clients_id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.clientInf !== nextProps.clientInf) {
      this.loadOptions(nextProps.clientInf.clients_id);
    }
  }

  loadOptions = async (cid: string) => {
    try {
      const { cities } = await loadCities(cid);
      this.setState({
        cities,
        isLoading: false,
      });
    } catch(ex) {
      this.setState({
        error: true,
        isLoading: false,
      });
    }
  }

  getEmptyOption = () => {
    if (this.state.isLoading) {
      return 'Cargando...';
    }
    if (this.state.error) {
      return 'Error Cargando datos';
    }
    return '---';
  }

  props: {
    name: string,
    onChange: Function,
    value: ?string,
    clientInf: Object,
  }

  render() {
    return (
      <Select
        name={this.props.name}
        onChange={this.props.onChange}
        value={this.props.value}
      >
        <option value="">{this.getEmptyOption()}</option>
        {Object.keys(this.state.cities).map((key: string) => (
          <option key={key} value={key}>{this.state.cities[key]}</option>
        ))}
      </Select>
    );
  }
}

export default connect(state => ({
  clientInf: state.client.info,
}))(CitySelect);



// WEBPACK FOOTER //
// ./src/components/BuildingsView/FiltersBar/CitySelect/index.js